export enum ShotsRoutes {
  AggMatches = 'agg-matches',
  ArchiveByList = 'archive-by-list',
  CountFiresSince = 'count-fires-since',
  CountShotsSince = 'count-shots-since',
  GetById = 'get-by-id',
  GetByIds = 'get-by-ids',
  GetLastShot = 'get-last-shot',
  GetMatches = 'get-matches',
  GetPrecursorSummary = 'get-precursor-summary',
  UpdateShot = 'update-shot',
}
